import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b127636")

_pushScopeId("data-v-0b127636")
const _hoisted_1 = {
  id: "host-info",
  "data-test": "host-info"
}
const _hoisted_2 = { id: "host-labels" }
const _hoisted_3 = { id: "hardwareId" }
const _hoisted_4 = {
  class: "kn-list-item",
  "data-test": "list-item"
}
const _hoisted_5 = { class: "kn-list-item-text" }
const _hoisted_6 = { class: "kn-list-item-text" }
const _hoisted_7 = { class: "kn-list-item-text-secondary" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_KnInputFile = _resolveComponent("KnInputFile")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Button = _resolveComponent("Button")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("p", null, _toDisplayString(_ctx.$t('licenseDialog.hostName')) + ":", 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('licenseDialog.hardwareId')) + ":", 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('licenseDialog.numberOfCpu')) + ":", 1)
      ]),
      _createVNode("div", null, [
        _createVNode("p", null, _toDisplayString(_ctx.selectedHost.hostName), 1),
        _createVNode("p", _hoisted_3, _toDisplayString(_ctx.selectedHost.hardwareId), 1),
        _createVNode("p", null, _toDisplayString(_ctx.cpunumber), 1)
      ])
    ]),
    _createVNode(_component_Toolbar, { class: "kn-toolbar--transparent p-mb-2" }, {
      end: _withId(() => [
        _withDirectives(_createVNode(_component_FabButton, {
          icon: "fas fa-plus",
          style: _ctx.licenseDialogDescriptor.fabButton.style,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setUploadType('', false))),
          "data-test": "new-button"
        }, null, 8, ["style"]), [
          [
            _directive_tooltip,
            _ctx.$t('licenseDialog.dataRequired'),
            void 0,
            { top: true }
          ]
        ]),
        (!_ctx.uploading)
          ? (_openBlock(), _createBlock(_component_KnInputFile, {
              key: 0,
              label: "",
              changeFunction: _ctx.uploadLicense,
              accept: ".lic",
              triggerInput: _ctx.triggerUpload
            }, null, 8, ["changeFunction", "triggerInput"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Listbox, {
      class: "kn-list--column kn-list-no-border-right",
      style: _ctx.licenseDialogDescriptor.list.style,
      options: _ctx.licensesList
    }, {
      empty: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('licenseDialog.noLicenses')), 1)
      ]),
      option: _withId((slotProps) => [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Avatar, {
            image: require(`@/assets/images/licenseImages/${slotProps.option.product}.png`),
            size: "medium"
          }, null, 8, ["image"]),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", null, _toDisplayString(slotProps.option.product), 1),
            _createVNode("span", {
              class: ["kn-list-item-text-secondary", _ctx.setLicenseClass(slotProps.option.status)]
            }, _toDisplayString(_ctx.licenseText(slotProps.option.status)), 3)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('licenseDialog.licenseId')) + ":", 1),
            _createVNode("span", null, _toDisplayString(slotProps.option.licenseId), 1)
          ]),
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-download",
            class: "p-button-link",
            onClick: ($event: any) => (_ctx.downloadLicence(slotProps.option.product)),
            "data-test": "download-button"
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('licenseDialog.downloadLicense'),
              void 0,
              { top: true }
            ]
          ]),
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-pencil",
            class: "p-button-link",
            onClick: ($event: any) => (_ctx.setUploadType(slotProps.option.product, true)),
            "data-test": "edit-button"
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('licenseDialog.changeLicense'),
              void 0,
              { top: true }
            ]
          ]),
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-trash",
            class: "p-button-link",
            onClick: ($event: any) => (_ctx.showDeleteDialog(slotProps.option.product)),
            "data-test": "delete-button"
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('licenseDialog.deleteLicense'),
              void 0,
              { top: true }
            ]
          ])
        ])
      ]),
      _: 1
    }, 8, ["style", "options"]),
    _createVNode(_component_Dialog, {
      header: "Error",
      visible: _ctx.displayWarning,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.displayWarning = $event))
    }, {
      footer: _withId(() => [
        _createVNode(_component_Button, {
          label: "Ok",
          icon: "pi pi-check",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayWarning = false))
        })
      ]),
      default: _withId(() => [
        _createVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
})